import { EHarvestingView, HarvestingViewTitleMapping } from './constants';

export const getHarvestingViewTitle = (view: EHarvestingView): string => {
  return HarvestingViewTitleMapping[view] || '';
};
